import { render, staticRenderFns } from "./remove-link-modal.vue?vue&type=template&id=1d04cc87"
import script from "./remove-link-modal.vue?vue&type=script&lang=js"
export * from "./remove-link-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports